import { useCallback, useEffect, useMemo, useState } from 'react';
import { useTranslation } from 'react-i18next';

import { Layout } from '../../../../../components/auth';
import { Button, Input } from '../../../../../components/common';
import { FetchStatus } from '../../../../../enums';
import { useAuth, useForgotPassword, useResetForgotPasswordStatus } from '../../../../../features/auth';
import { isEmailValid } from '../../../../../utils';
import { IForgotPasswordEmailProps } from './types';

export const ForgotPasswordEmail = ({ onComplete }: IForgotPasswordEmailProps) => {
  const { t } = useTranslation();
  const [email, setEmail] = useState('');
  const forgotPassword = useForgotPassword();
  const resetForgotPasswordStatus = useResetForgotPasswordStatus();
  const {
    status: { forgotPassword: forgotPasswordStatus },
  } = useAuth();

  const isValid = useMemo(() => isEmailValid(email), [email]);

  const forgot = useCallback(() => {
    forgotPassword(email);
  }, [forgotPassword, email]);

  useEffect(() => {
    resetForgotPasswordStatus();
  }, []);

  useEffect(() => {
    if (forgotPasswordStatus === FetchStatus.SUCCESS) {
      resetForgotPasswordStatus();
      onComplete();
    }
  }, [forgotPasswordStatus]);

  return (
    <Layout title={t('forgotPassword.title.request')}>
      <p className="typography-paragraph-3 text-text-secondary mt-2 mb-6">{t('forgotPassword.subtitle.request')}</p>

      <Input
        value={email}
        label={t('forgotPassword.field.email.label')}
        onChange={setEmail}
        placeholder={t('forgotPassword.field.email.placeholder')}
        type="email"
      />

      <div className="flex mt-6">
        <Button
          text={t('forgotPassword.button.reset')}
          disabled={!isValid}
          onClick={forgot}
          loading={forgotPasswordStatus === FetchStatus.LOADING}
        />
        <Button text={t('forgotPassword.button.back')} path="/login" type="tertiary" className="ml-3" />
      </div>
    </Layout>
  );
};
